// Mesma ordem de domain.VinculoColorPalette no backend (ordem de atribuição automática).
export const VINCULO_COLORS = [
  { key: "blue", label: "Azul" },
  { key: "orange", label: "Laranja" },
  { key: "violet", label: "Violeta" },
  { key: "brown", label: "Marrom" },
  { key: "pink", label: "Rosa" },
  { key: "slate", label: "Cinza-azulado" },
  { key: "indigo", label: "Índigo" },
  { key: "charcoal", label: "Grafite" },
];

export const VINCULO_COLOR_KEYS = VINCULO_COLORS.map((c) => c.key);

// Token semântico (claro/escuro) da cor do vínculo; chave desconhecida ou ausente cai num
// cinza neutro em vez de quebrar a tela.
export function vinculoColorToken(key) {
  return VINCULO_COLOR_KEYS.includes(key) ? `vinculo-${key}` : "app-muted-fg";
}

export function vinculoColorLabel(key) {
  return VINCULO_COLORS.find((c) => c.key === key)?.label ?? "Sem cor";
}
